import React, { useState, useRef, useEffect } from "react";
import Allergens from "./common/Allergens.svg";
import { v4 as uuidv4 } from "uuid";

import { CupcakeInfoPopup } from "../styles";
import { capitalize } from "lodash";
import AddToSelection from "./AddToSelection";
import { Markup } from "interweave";
import CGTLogo from "./CGTLogo";
import TVSLogo from "./VeganSocietyLogo";

const targetMacros = [
  "kj",
  "kcal",
  "fat",
  "saturated_fat",
  "carbohydrate",
  "sugar",
  "protein",
  "salt",
  "fibre",
];

const allergens = all_allergens;

const AvailableProductInfo = ({
  product,
  setFocusedProduct,
  focusedProduct,
  handleAddItem,
  selection,
  updateItemAdd,
  updateItemRemove,
}) => {
  const Slider = useRef();
  const [activeTab, setActiveTab] = useState("product");

  const handleSwitchTab = (e, type) => {
    e.preventDefault();
    if (!e.target.classList.contains("active")) {
      setActiveTab(type);
      Slider.current.classList.toggle("slide");
    }
  };

  const ProductInfoPortal = useRef(null);

  useEffect(() => {
    const handleOuterClick = (e) => {
      if (
        ProductInfoPortal.current &&
        !ProductInfoPortal.current.contains(e.target)
      ) {
        setFocusedProduct(null);
      } else return;
    };
    if (focusedProduct) {
      document.addEventListener("click", handleOuterClick, true);
      return () => {
        document.removeEventListener("click", handleOuterClick, true);
      };
    } else {
      return;
    }
  }, [focusedProduct]);

  return (
    <CupcakeInfoPopup $activeTab={activeTab}>
      <div className="inner" ref={ProductInfoPortal}>
        <div className="wrapper-outer">
          <div className="wrapper" ref={Slider}>
            <div
              className={`inner__product-slider-section inner__product-info ${
                activeTab === "product" ? "active" : ""
              }`}
            >
              <span
                className="modal-close d-md-none"
                onClick={() => setFocusedProduct(null)}
              >
                &times;
              </span>
              <div className="inner__product-info--desc">
                <h5 className="tt-title d-block">{product.frontend_title}</h5>
                <p>{product.description}</p>
              </div>
              <div className="inner__product-info--img">
                <img
                  src={product.img}
                  alt={`${product.frontend_title}-info-img `}
                />
                <AddToSelection
                  product={product}
                  handleAddItem={handleAddItem}
                  selection={selection}
                  updateItemAdd={updateItemAdd}
                  updateItemRemove={updateItemRemove}
                />
              </div>
              <div className="allergens">
                <h6>Contains</h6>
                <div className="allergens-section">
                  {product.allergens.map((allergen) => {
                    return (
                      <div key={uuidv4()} className="allergen-tile">
                        <img src={allergens[allergen].img} />
                        <span>{allergens[allergen].frontend_title}</span>
                      </div>
                    );
                  })}
                  {product.cgt?.id && <CGTLogo logo={product.cgt.logo} id={product.cgt.id} />}
                  {product.veganSocietyLogo && <TVSLogo logo={product.veganSocietyLogo} />}
                </div>
              </div>
              <div className="product-info__ats-mobile">
                <AddToSelection
                  product={product}
                  handleAddItem={handleAddItem}
                  selection={selection}
                  updateItemAdd={updateItemAdd}
                  updateItemRemove={updateItemRemove}
                />
              </div>
              <div
                className={`product-info__composition ${
                  product.composition.base &&
                  product.composition.icing &&
                  product.composition.decoration &&
                  product.composition.filling
                    ? "quadrant"
                    : ""
                }`}
              >
                {product.composition.base && (
                  <div>
                    <span className="product-info__composition--heading">
                      Sponge
                    </span>
                    <span>{product.composition.base}</span>
                  </div>
                )}
                {product.composition.icing && (
                  <div>
                    <span className="product-info__composition--heading">
                      Icing
                    </span>
                    <span>{product.composition.icing}</span>
                  </div>
                )}
                {product.composition.decoration && (
                  <div>
                    <span className="product-info__composition--heading">
                      Decoration
                    </span>
                    <span>{product.composition.decoration}</span>
                  </div>
                )}
                {product.composition.filling && (
                  <div>
                    <span className="product-info__composition--heading">
                      Filling
                    </span>
                    <span>{product.composition.filling}</span>
                  </div>
                )}
              </div>
            </div>
            <div
              className={`inner__product-slider-section inner__product-nutrition ${
                activeTab === "nutritional" ? "active" : ""
              }`}
            >
              <div className="product-nutrition__nutritionals">
                <span
                  className="modal-close d-md-none"
                  onClick={() => setFocusedProduct(null)}
                >
                  &times;
                </span>
                <div className="h-100">
                  <h5 className="tt-title">{product.frontend_title}</h5>
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th className="text-right">100g</th>
                        <th className="text-right pr-2">Per Item</th>
                      </tr>
                    </thead>
                    <tbody>
                      {targetMacros.map((targetMacro) => (
                        <tr key={uuidv4()}>
                          <td className="pl-2">
                            {`${
                              targetMacro === "kcal"
                                ? "Energy (kCal)"
                                : targetMacro === "kj"
                                ? "Energy (kj)"
                                : targetMacro === "saturated_fat"
                                ? "of which Saturates"
                                : targetMacro === "sugar"
                                ? "of which Sugars"
                                : capitalize(targetMacro.replaceAll("_", " "))
                            } ${
                              targetMacro !== "kcal" && targetMacro !== "kj"
                                ? "(g)"
                                : ""
                            }`}
                          </td>
                          <td className="text-right">
                            {product.nutrition.per_hundred[targetMacro]}
                          </td>
                          <td className="text-right pr-2">
                            {product.nutrition.per_portion[targetMacro]}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              className={`inner__product-slider-section inner__product-ingredients ${
                activeTab === "ingredients" ? "active" : ""
              }`}
            >
              <span
                className="modal-close d-md-none"
                onClick={() => setFocusedProduct(null)}
              >
                &times;
              </span>
              <div>
                <h5 className="tt-title">{product.frontend_title}</h5>

                <Markup
                  className="product-ingredients__ingredient-list"
                  content={product.ingredients}
                  containerTagName="div"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="nav-toggles">
          <button
            className={`${activeTab === "product" ? "active" : ""}`}
            onClick={(e) => handleSwitchTab(e, "product")}
          >
            product info
          </button>
          <button
            className={`${activeTab === "nutritional" ? "active" : ""}`}
            onClick={(e) => handleSwitchTab(e, "nutritional")}
          >
            nutritional info
          </button>
          <button
            className={`${activeTab === "ingredients" ? "active" : ""}`}
            onClick={(e) => handleSwitchTab(e, "ingredients")}
          >
            ingredients
          </button>
        </div>
      </div>
    </CupcakeInfoPopup>
  );
};

export default AvailableProductInfo;
